export default __webpack_public_path__ + "static/media/mc_cv_4.cc62b2ed.jpg";